import React from "react";
import PageShell from "@/components/site/PageShell";
import PageHeader from "@/components/site/PageHeader";
import { Container, Eyebrow, Body, ArrowLink, Reveal, Rich } from "@/components/site/ui";
import { SOBRE, PRATICA, RTL, IMG, SHOW_PENDING, isPending } from "@/content/site";

// Campos incompletos só aparecem na pré-visualização.
const visible = (x) => SHOW_PENDING || (!isPending(x.d) && !isPending(x.url));

const SobrePage = () => {
    const formacao = SOBRE.formacao.filter(visible);
    const links = SOBRE.links.filter(visible);
    return (
        <PageShell path="/sobre" title="Sobre" sections={["header", "bio", "formacao"]}>
            <PageHeader testId="sobre-page-header" eyebrow={SOBRE.eyebrow} title={SOBRE.title} img={IMG.sobre} alt="Ponte sobre rio amazônico" />

            <section data-section-id="bio" className="py-12 md:py-20">
                <Container className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <Reveal className="md:col-span-10 flex flex-col gap-8" delay={120}>
                        <p data-testid="sobre-curta" className="font-serif font-light text-[21px] md:text-[25px] leading-[1.55] text-[#F2EFE5]">{SOBRE.curta}</p>
                        <Body>{SOBRE.producao}</Body>
                        <Body>{SOBRE.docencia}</Body>
                        <Body>{SOBRE.publicacoes}</Body>
                        <div className="flex flex-wrap gap-8">
                            <ArrowLink to="/pesquisa" testId="sobre-link-pesquisa">Pesquisa</ArrowLink>
                            <ArrowLink to="/docencia" testId="sobre-link-docencia">Docência</ArrowLink>
                            <ArrowLink to="/publicacoes" testId="sobre-link-publicacoes">Publicações</ArrowLink>
                        </div>
                        <div className="pt-8 border-t border-[#1B3025]">
                            <Eyebrow>{PRATICA.eyebrow}</Eyebrow>
                            <Body>{PRATICA.text}</Body>
                            <p className="mt-5 font-sans font-light text-[13.5px] text-[#B0B6A6]">
                                {RTL.eyebrow}:{" "}
                                <a href={RTL.url} target="_blank" rel="noopener noreferrer" data-testid="sobre-rtl-link" className="text-[#C7A659] border-b border-[#C7A659]/40 hover:text-[#e2c886]">{RTL.label} ↗</a>
                            </p>
                        </div>
                    </Reveal>
                </Container>
            </section>

            <section data-section-id="formacao" className="relative bg-[#F2EFE5] text-[#0E2018] py-20 md:py-24">
                <div aria-hidden="true" className="absolute inset-0 paper-grain" />
                <Container className="relative grid grid-cols-1 md:grid-cols-2 gap-14">
                    {formacao.length > 0 && (
                        <Reveal>
                            <Eyebrow light>Formação</Eyebrow>
                            <ul className="flex flex-col">
                                {formacao.map((f) => (
                                    <li key={f.t} className="py-5 border-t border-[#0E2018]/15">
                                        <p className="font-serif text-[20px]">{f.t}</p>
                                        <p className="mt-2 text-[13px] text-[#6b6a52]">{f.d}</p>
                                    </li>
                                ))}
                            </ul>
                        </Reveal>
                    )}
                    <Reveal delay={120}>
                        <Eyebrow light>Publicações registradas</Eyebrow>
                        <ul className="flex flex-col">
                            {links.map((l) => (
                                <li key={l.t} className="py-4 border-t border-[#0E2018]/15 font-sans font-light text-[14px]">
                                    {isPending(l.url) ? (
                                        <span className="flex flex-wrap items-center gap-3">{l.t} <Rich text={l.url} /></span>
                                    ) : (
                                        <a href={l.url} target="_blank" rel="noopener noreferrer" className="hover:text-[#8a6a22] transition-colors">{l.t} ↗</a>
                                    )}
                                </li>
                            ))}
                        </ul>
                        <div className="mt-10">
                            <ArrowLink to="/contato" testId="sobre-link-contato" light>Contato e cooperação</ArrowLink>
                        </div>
                    </Reveal>
                </Container>
            </section>
        </PageShell>
    );
};

export default SobrePage;
